export default function (props) {
    const {note, number} = props

    const listStrings = note.split(" ")

    if (listStrings.length > number) {
        let new_arr = []
        for (let i = 0; i < number; i++) {
            new_arr.push(listStrings[i])
        }
        return new_arr.join(' ') + '...'
    } else {
        return note
    }
}